import $ from 'jquery';
import Config from '../config';
import {PhoneNumberUtil} from 'google-libphonenumber';

export default {
  bgImageUrl: function (imageUrl) {
    return 'url("' + imageUrl + '")';
  },
  splitFilter: function (filter) {
    const res = {};
    filter.split('&').forEach(function (pair) {
      const ar = pair.split('=');
      res[ar[0]] = ar[1];
    });
    return res;
  },
  keysAndProps: function (obj) {
    const res = Object.keys(obj);
    console.log(res);
    for (let key in res) {
      const prop = obj[key];
      if (Array.isArray(prop)) {
        res.push(prop);
      }
    }

    return res;
  },
  isObject: function (val) {
    if (val === null) {
      return false;
    }
    return ( (typeof val === 'function') || (typeof val === 'object') );
  },

  imagePathCache: {},
  imagePath: function (image) {
    let path = this.imagePathCache[image];
    if (!path) {
      path =(Config.kioskStandAlone || document.kvConfig.dev ? './' : '/content/Views/kv/') + image;
      this.imagePathCache[image] = path;
    }

    return path;
  },
  /**
   * return the path without last part which is supposelly the file name
   * @param {string} path
   * @param {int} [count=1]
   */
  pathPrefix: function (path, count) {
    count = count || 1;
    while (count-- > 0) {
      const index = path.lastIndexOf("/");
      if (index === -1) {
        return path;
      }

      path = path.substr(0, index);
    }

    return path;
  },

  /**
   * Converts a string to a boolean value
   * @param value
   */
  toBoolean: function (value) {
    if (typeof (value) === 'string') {
      value = value.toLowerCase();
    }
    switch (value) {
      case true:
      case "true":
      case 1:
      case "1":
      case "on":
      case "yes":
        return true;
      default:
        return false;
    }
  },

  convertKeysToCamelCase: function (obj) {
    if (!obj || typeof obj !== "object") {
      return null;
    }

    if (obj instanceof Array) {
      return $.map(obj, function (value) {
        return this.convertKeysToCamelCase(value);
      });
    }

    const newObj = {};
    $.each(obj, function (key, value) {
      key = key.charAt(0).toLowerCase() + key.slice(1);
      newObj[key] = value;
    });

    return newObj;
  },
  toCamel: function (o) {
    let build, key, destKey, value;

    if (o instanceof Array) {
      build = [];
      for (key in o) {
        value = o[key];

        if (typeof value === "object") {
          value = this.toCamel(value);
        }
        build.push(value);
      }
    } else {
      build = {};
      for (key in o) {
        if (o.hasOwnProperty(key)) {
          destKey = (key.charAt(0).toLowerCase() + key.slice(1) || key).toString();
          value = o[key];
          if (value !== null && typeof value === "object") {
            value = this.toCamel(value);
          }

          build[destKey] = value;
        }
      }
    }
    return build;
  },
  ignoreDefault: function (e) {
    e.stopPropagation();
    e.preventDefault();
    //e.nativeEvent.stopImmediatePropagation();
  },

  ignore: function (e, cb) {
    this.ignoreDefault(e);
    cb();
  },


  playVideo: function (id) {
    ///TODO: When Girl videos are updated remove "|| true"
    if (!document.kvConfig.kioskMode || Config.isQTEmbedded() || true) {
      return;
    }
    const $guide = $(id);
    if (!$guide.length) {
      return;
    }
    const guide = $guide[0];
    $guide.off('canplaythrough').on('canplaythrough', function () {
      $guide.show();
      guide.play();
    });
    guide.load();
  },
  hideVideo: function (id) {
    const $guide = $(id);
    if (!$guide.length) {
      return;
    }
    const guide = $guide[0];
    $guide.hide();
    guide.pause();
  },
  getIntroVideo: function (view) {
    const path = Config.kioskStandAlone ? "./videos/video_guide/" : 'https://s3.amazonaws.com/intro-videos/';
    switch (view) {
      case 'review':
        return path + 'Visualizer-Tools-Totals-25M.webm';
      case 'intro':
        return path + 'Kitchen-Visualizer-25M.webm';
      default:
        return '';
    }
  },
  exportCanvasAsPNG: function (canvasElement, fileName) {
    const MIME_TYPE = "image/png";
    let imgURL = canvasElement.toDataURL(MIME_TYPE);

    /* Change MIME type to trick the browser to download the file instead of displaying it */
    imgURL = imgURL.replace(/^data:image\/[^;]*/, 'data:application/octet-stream');
    /* In addition to <a>'s "download" attribute, you can define HTTP-style headers */
    //imgURL = imgURL.replace(/^data:application\/octet-stream/, 'data:application/octet-stream;headers=Content-Disposition%3A%20attachment%3B%20filename=' + fileName);

    const dlLink = document.createElement('a');
    dlLink.download = fileName;
    dlLink.href = imgURL;
    dlLink.dataset.downloadurl = [MIME_TYPE, dlLink.download, dlLink.href].join(':');

    document.body.appendChild(dlLink);
    dlLink.click();
    document.body.removeChild(dlLink);
  },
  monads: {
    ifNotNull: function (o, notNullCallback) {
      if (o) {
        return notNullCallback(o);
      }

      return null;
    }
  },
  pnpoly: function( points, test ) {
    var i, j, c = false;
    for( i = 0, j = points.length-1; i < points.length; j = i++ ) {
      if( ( ( points[i].y > test.y ) != ( points[j].y > test.y ) ) &&
        ( test.x < ( points[j].x - points[i].x ) * ( test.y - points[i].y ) / ( points[j].y - points[i].y ) + points[i].x ) ) {
        c = !c;
      }
    }
    return c;
  },
  isEmail: function (email) {
    if (!email || email.indexOf('@') === -1) {
      return false;
    }

    // eslint-disable-next-line no-useless-escape
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i;
    return re.test(email);
  },
  isZip: function (zip) {
    const regex = /[a-zA-Z0-9][a-zA-Z0-9\- ]{0,10}[a-zA-Z0-9]/;
    // const regex = /(^\d{5}(?:[\s]?[-\s][\s]?\d{4})?$)/; // this on can not support H3H 2H2, which is real Quebec code
    return regex.test(zip);
  },
  // isPhoneNumber: function (phone) {
  //   if (!phone) {
  //     return false;
  //   }
  //   const count = phone.replace(/[^0-9]/g, "").length;
  //   return count === 10 || count === 11;
  // },
  isPhoneNumber: function (phone, region) {
    region = region || "US";
    const phoneUtil = PhoneNumberUtil.getInstance();
    try {
      if (phone) {
        const parsedPhone = phoneUtil.parse(phone, region);
        return phoneUtil.isPossibleNumber(parsedPhone) && phoneUtil.isValidNumberForRegion(parsedPhone, region); // /^\+?\d{10,16}$/.test(phone);
      }
      return false;
    } catch(ex) {
      return false;
    }
  },
  getPhoneFormatted: (phone, region) => {
    region = region || "US";
    const phoneUtil = PhoneNumberUtil.getInstance();
    try {
      if (phone) {
        const parsedPhone = phoneUtil.parse(phone, region);
        return phoneUtil.formatInOriginalFormat(parsedPhone, region);
      }
    } catch(ex) {
      console.log(ex);
    }
    return phone;
  },
  getUserPhoneSplitted: (phone, oldCountry = "") => {
    const googlePhouneUtilInstance = PhoneNumberUtil.getInstance();
    if (Config.isDevMode()) {
      console.log("googlePhouneUtilInstance", googlePhouneUtilInstance);
    }
    const allRegions = googlePhouneUtilInstance.getSupportedRegions();
    // console.log("allRegions", allRegions);
    try {
      const parsedPhone = googlePhouneUtilInstance.parse(phone);
      // if (Config.isDevMode()) {
      //   console.log("parsedPhone", parsedPhone);
      // }
      const phoneCountry = oldCountry && allRegions.includes(oldCountry)
      && googlePhouneUtilInstance.isValidNumberForRegion(parsedPhone, oldCountry)
        ? oldCountry
        : allRegions.find(regionCode => googlePhouneUtilInstance.isValidNumberForRegion(parsedPhone, regionCode)) || ""
      // console.log("phoneCountry", phoneCountry);
      return {
        country: {
          dialCode: "" + parsedPhone.getCountryCode(),
          iso2: phoneCountry.toLowerCase()
        },
        phoneNumber: "" + parsedPhone.getNationalNumber() // we keep it as as string
      }
    } catch (ex) {
      if (Config.isDevMode()) {
        console.log("couldn't parse the phone", phone);
      }
    }
    const phoneSplitted = phone ? phone.match(/(\+(\d.*?)\s)?(.*)/) : [];
    return {
      phoneNumber: phoneSplitted[3] || phone || ""
    }
  },
  parseUserResponse: function(responseData, oldCountry = "") {
    const {phoneNumber, country} = this.getUserPhoneSplitted(responseData.values.phone, oldCountry || responseData.values.country || "");
    const newUserInfo = {
      email: responseData.email,
      firstName: responseData.values.firstName,
      lastName: responseData.values.lastName,
      phoneNumber,
      postal: responseData.values.postal,
      isNew: false,
      password: ""
    };
    if (country) {
      newUserInfo.country = country;
    }
    ["address1", "address2", "firstName", "lastName", "postal", "city", "provence"].forEach(key => {
      if (responseData.values && responseData.values[key]) {
        const realKey = (key === "provence") ? "state" : key;
        newUserInfo[realKey] = responseData.values[key] === "N/A" ? "" : responseData.values[key]
      }
    })
    return newUserInfo
  },
  parseAddressResponseObject: function(shippingAddress) {
    return {
      fullName: shippingAddress ? shippingAddress.name || shippingAddress.fullName || "" : "",
      address1: shippingAddress ? shippingAddress.address1 : "",
      address2: shippingAddress ? shippingAddress.address2 : "",
      city: shippingAddress ? shippingAddress.city : "",
      state: shippingAddress ? shippingAddress.state || shippingAddress.provence : "",
      postal: shippingAddress ? shippingAddress.zip || shippingAddress.postal : "",
      country: shippingAddress ? shippingAddress.country : ""
    }
  },
  parseShippingAndBillingResponse: function(responseData) {
    const {billingAddress, shippingAddress, billingSameAsShipping} = responseData;
    return {
      shippingAddress: this.parseAddressResponseObject(shippingAddress),
      billingAddress: this.parseAddressResponseObject(billingAddress),
      billingSameAsShipping: !!billingSameAsShipping, // in case it comes undefined
    }
  },
  isMobile: () => {
    return (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent)
        // eslint-disable-next-line no-useless-escape
        || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0, 4)))
  },
  getRandomInt(min, max) {
    return Math.floor(Math.random() * (max - min)) + min;
  },
  /**
   * Checks input value on errors, returns all errors array
   * @param currentValue {string|number}
   * @param property {string}
   * @param fabricatorData {object}
   * @returns {array}
   */
  getValidationErrors(currentValue, property, fabricatorData) {
    const errors = [];

    if (fabricatorData.isCaesarStone) {
      switch (property) {
        case "lastName": {
          if (!currentValue) {
            errors.push("assignPopup.errors.fieldRequired");
            return errors
          }
          if (currentValue.length === 1) {
            errors.push("assignPopup.errors.shortName");
          } else if (currentValue.length > 50) {
            errors.push("assignPopup.errors.longName");
          }
          if (!/^[A-Z\s\'\-\&\.a-z]+$/.test(currentValue)) {
            errors.push("assignPopup.errors.nameIsIncorrect");
          }
          break;
        }
        case "city":
        case "state": {
          if (!currentValue) {
            errors.push("assignPopup.errors.fieldRequired");
            return errors
          }
          break;
        }
      }
      return errors
    }

    switch (property) {
      case "firstName": {
        if (!currentValue) {
          errors.push("assignPopup.errors.fieldRequired");
          return errors
        }
        if (currentValue.length === 1) {
          errors.push("assignPopup.errors.shortName");
        } else if (currentValue.length > 50) {
          errors.push("assignPopup.errors.longName");
        }
        if (!/^[A-Z\s\'\-\&\.a-z]+$/.test(currentValue)) {
          errors.push("assignPopup.errors.nameIsIncorrect");
        }
        break;
      }
      case "email": {
        if (!currentValue) {
          errors.push("assignPopup.errors.fieldRequired");
          return errors
        }
        if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(currentValue)) {
          errors.push("assignPopup.errors.invalidEmail");
        }
        break;
      }
      case "phoneNumber": {
        if (!currentValue) {
          errors.push("assignPopup.errors.fieldRequired");
          return errors
        }
        // we have another check, isPhoneNumber
        // if (!/^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/.test(currentValue)) {
        //   errors.push("assignPopup.errors.invalidEmail");
        // }
        break;
      }
      case "postal": {
        if (!currentValue) {
          errors.push("assignPopup.errors.fieldRequired");
          return errors
        }
        if (!this.isZip(currentValue)) {
          errors.push("assignPopup.errors.incorrectPostal");
          return errors
        }
        break;
      }
      case "phone2": {
        if (currentValue.length > 20) {
          errors.push("assignPopup.errors.phoneNumberIsTooLong");
        }
        break;
      }
      case "Project Description": {
        if (!currentValue) {
          errors.push("assignPopup.errors.fieldRequired");
          return errors
        }
        break;
      }
    }
    return errors
  },
  hasErrors: (errorsObject) => {
    return !!(Object.keys(errorsObject).length && Object.keys(errorsObject).some(key => errorsObject[key] && errorsObject[key].length))
  },
  textSubStringEllipsis: (text, length) => {
    if (!text || !length || (text.length < length)) {
      return text || ""
    }
    return text.substring(0, length) + "..."
  },
  getUrlFromString: (text) => {
    if (!text) {
      return ""
    }
    return text.toLowerCase().replace(/ /g, "-")
  }
};

